import { Box, Button, Typography } from '@mui/material';

/**
 * The properties for another session component
 */
interface AnotherSessionProps {
  /**
   * A function to close the checkout dialog
   */
  closeDialog: () => void;
  /**
   * A function that allows the current manager to forcefully end another session
   */
  endExistingSession: () => void;
  /**
   * The name of the person who owns th existing session
   */
  ownerName: string;
  /**
   * A boolean value to communicates whether the outer component is loading
   */
  isLoading: boolean;
}

/**
 * This is the component we show managers if another manager already
 * has an active session.
 */
const AnotherSession = (props: AnotherSessionProps) => (
  <Box display="flex" flexDirection="column" gap={2} mt={2}>
    <Typography gutterBottom>
      There&apos;s an existing checkout session started by{' '}
      <strong>{props.ownerName}</strong>.
    </Typography>
    <Typography gutterBottom>
      If needed, you can choose to end it. Before doing so, we recommend
      checking in with them to ensure they&apos;re not actively using it. The
      session may not currently be in use and could have been left open
      unintentionally.
    </Typography>
    <Box display="flex" justifyContent="flex-end" gap={1}>
      <Button onClick={props.closeDialog} color="secondary" variant="outlined">
        Close
      </Button>
      <Button
        variant="contained"
        color="warning"
        onClick={props.endExistingSession}
        disabled={props.isLoading}
      >
        End Existing Session
      </Button>
    </Box>
  </Box>
);

export default AnotherSession;
